import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const EMRDirectory = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Complete EMR Software Directory
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Explore detailed information about leading behavioral health EMR systems
          </p>
        </div>
        
        <Card>
          <CardHeader>
            <CardTitle>EMR System Reviews & Comparisons</CardTitle>
            <CardDescription>In-depth analysis of features, pricing, and capabilities</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <a href="/emr/therapynotes" className="text-primary hover:underline font-medium">TherapyNotes</a>
              <a href="/emr/simplepractice" className="text-primary hover:underline font-medium">SimplePractice</a>
              <a href="/emr/opus" className="text-primary hover:underline font-medium">Opus</a>
              <a href="/emr/doxy" className="text-primary hover:underline font-medium">Doxy.me Practice Management</a>
              <a href="/emr/kipu" className="text-primary hover:underline font-medium">Kipu EMR</a>
              <a href="/emr/valant" className="text-primary hover:underline font-medium">Valant EHR</a>
              <a href="/emr/epic" className="text-primary hover:underline font-medium">Epic</a>
              <a href="/emr/athenahealth" className="text-primary hover:underline font-medium">athenahealth</a>
              <a href="/emr/nextgen" className="text-primary hover:underline font-medium">NextGen Healthcare</a>
              <a href="/emr/kareo" className="text-primary hover:underline font-medium">Kareo</a>
            </div>
          </CardContent>
        </Card>

        <div className="mt-8 text-center">
          <p className="text-muted-foreground mb-4">
            Not sure which EMR is right for you?
          </p>
          <a 
            href="/get-recommendation" 
            className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background bg-primary text-primary-foreground hover:bg-primary/90 h-10 py-2 px-4"
          >
            Get Free EMR Analysis
          </a>
        </div>
      </div>
    </section>
  );
};

export default EMRDirectory;
